import React, { Suspense } from 'react';
import profile from './profile/MyProfile';
import requestredeem from '../src/Redeem/Request_Redeem';
import responsiblegamingquestionnaire from './AddCash/ResponsableGamingForm';
import termsandconditions from './Common/TermsandConditions';
import rummyrules from './AboutUs/RummyRules';
import aboutrummy from './AboutUs/AboutRummy';
import bonussummary from './BonusSummaryA23';
// import CleverTapUtil from './CleverTapUtil';
import navarrow from "./assets/back_btn.png";
// import { useLocation } from 'react-router-dom';
import { UserProvider } from './OEMChanges/OemAssetsImport.js';
import { VernacularContext, LanguageProvider } from './OEMChanges/LanguageContext.js';


import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
  Switch
} from "react-router-dom";

import { Provider } from 'react-redux';
import store from './redux/CreateStore.js';
import { hot } from "react-hot-loader";
import myaccount from './profile/MyAccount';
import rummyvariants from './AboutUs/RummyVariants';
import changepassword from './profile/ChangePassword';
import redeem from './Redeem/Redeem';
import redeemhistorytwo from './Redeem/RedeemHistoryTwo';
import redeemRequestStatus from './Redeem/RedeemRequestSuccess'
import addupi from './models/VerifyUPI';
import addbankaccount from './Redeem/AddBankAccount';
import bankverificationalert from './Redeem/BankVerificationAlert';
import sampleaddcash from './SampleAddCash';
// import transactionsummary from './BonusPages/TransactionSummary';
// import ft2 from './BonusPages/FT2';
import ModelContainer from './Redeem/ModalContainer';
import apppreferences from '../src/Preferences/AppPreferences';
// import walletinfo from '../src/Wallet/WalletInfo';
import WalletInfoRevamp from './Wallet/WalletInfoRevamp';
import Alert from '../src/models/Toast';
import ifscpage from './OpenThirdPartyURL';
import redeemacepoints from "../src/Common/AcePoints"
import acepoints_termsandconditons from './Common/Acepoints_terms_conditions';
import redeeminfo from "../src/models/RedeemInfo"
import failedtranscations from "./BonusPages/FailedTranscations"
import summarybonus from './BonusPages/SummaryBonus';
import bonusoffers from '../src/Common/AcePoints';
import loyalty from '../src/Common/Loyalty';
import { networkStatus, updateAppVisibility } from './redux/actions/userAction';
// import BS2 from './BonusPages/BS2';
import ActiveOffers from './BonusPages/ActiveOffers';
import Loading from './models/Loading';
import { getProfileData } from './Services/userService';
import { WebToNativeMessage } from './Common/Utils';
import TransactionSummary from './TransactionSummary/TransactionSummary';
import Promotions from './BonusPages/Promotions';
import { notifyTokenReceived } from './api/AxiosInstance.js';
import AdBanner from './Common/AdBanner.js';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialStorage: false,
      enableHeader: 'Y',
      isLoading: false,
    }

    console.log("is loading", this.state.isLoading)


    window.addEventListener("offline", (event) => {
      store.dispatch(networkStatus("disconnected"));
    });

    window.addEventListener("online", (event) => {
      store.dispatch(networkStatus("connected"));
    });
  }

  callRedirectTo = () => {
    // WebToNativeMessage({ tokentype: "token", channeltype: "channel" })
  }

  onDocumentVisibilityChange = () => {
    console.log("YYYYYYYYYYYYYYYYY", window.location.href);
    store.dispatch(updateAppVisibility(document.hidden))
    window.dataToClient = (message) => {
      console.log("CALLING DATA TO CLIENT ON VISIBILITY CHANGE: ", message)
    }
    if (document.hidden === false) {
      console.log('Reloading!')
      if (window.location.href.search("Walletinfo") > 0 || window.location.href.search("walletinfo") > 0) {
        console.log('Reloading! dfgdgfgfg')
        window.location.reload(true)
      }
    }
    if (window.sessionStorage['reloadPageInRedeem'] === 'true' && window.location.href.search("redeem") > 0 && !(window.location.href.search("redeeminfo") > 0) && !(window.location.href.search("redeemhistory") > 0)) {
      window.location.reload(true)
    }
  }

  async componentWillMount() {
    const searchParams = (window.location.href).split('enableHeader=')[1]
    console.log('Search Params: ', (window.location.href).split('enableHeader=')[1])
    this.setState({
      enableHeader: searchParams
    })

    // if (process.env.REACT_APP_DISABLE_CONSOLE_STATEMENTS === "true") {
    //   this.disableLogs();
    // }
    if (process.env.REACT_APP_CHECK_VERSION === "true") {
      this.checkVersion();
    }
    this.callRedirectTo();
  }

  disableLogs() {
    try {
      let console = {};
      window.console = console
      console.log = function () { };
      console.warn = function () { };
      console.error = function () { };
    } catch (e) {
      console.log("error while disabling logs ", e);
    }
  }

  // checkVersion = () => {
  //   console.log("Checking version >>> ");
  //   let clientVersion = process.env.REACT_APP_CLIENT_VERSION; //Application version
  //   try {
  //     if (window.XMLHttpRequest) {
  //       let locationUrl = new URL(window.location.href);
  //       console.log("locationUrl:", locationUrl);

  //       let xmlRequest = new XMLHttpRequest();
  //       xmlRequest.onreadystatechange = (event) => {
  //         console.log(`xmlRequest Ready state >>> ${event.target.readyState}`)
  //         if (event.target.readyState === 4) {
  //           let xmlDocument = xmlRequest.responseXML;
  //           console.log("Document found inside try ", typeof xmlDocument);
  //           if (xmlDocument) {
  //             let versionElement = xmlDocument.getElementsByTagName("version");
  //             let version = versionElement[0]?.textContent;
  //             console.log(`Version from XML File : ${version}  Application version : ${clientVersion}`)
  //             if (version !== clientVersion) {
  //               // xmlURL = locationUrl.protocol + "//" + locationUrl.hostname + locationUrl.pathname + "version.xml?t=" + Math.random();
  //               // console.log("xmlURL: ", xmlURL);
  //                let redirectionURL = new URL(
  //                 locationUrl.protocol + "//" + locationUrl.hostname +
  //                locationUrl.pathname 
  //               );

  //               let locationURLSearchParams = new URLSearchParams(
  //                 locationURL.search
  //               );
  //               locationURLSearchParams.set("t", Math.random()); //replaces the existing timestamp (if any)

  //               redirectionURL.search = locationURLSearchParams.toString(); //updates with the remaining (if any) search params
  //               redirectionURL.hash = locationURL.hash; //hash (if already exists) in URL to be added

  //               console.log("redirectionURL:", redirectionURL);

  //               window.location.href = redirectionURL.href;

  //             } else {
  //               xmlURL = locationUrl.protocol + "//" + locationUrl.hostname + locationUrl.pathname + "version.xml?t=" + Math.random();
  //               console.log("NO HASH xmlURL: ", xmlURL);
  //             }
  //           }
  //         }
  //       };

  //       let xmlURL = "";
  //       if (process.env.REACT_APP_HASH_ROUTING === "true") {
  //         xmlURL = locationUrl.origin + "/version.xml?t=" + Math.random();
  //         console.log("xmlURL: ", xmlURL);
  //       } else {
  //         xmlURL = locationUrl.origin + "/version.xml?t=" + Math.random();
  //         console.log("NO HASH xmlURL: ", locationUrl, xmlURL);
  //       }
  //       xmlRequest.open("GET", xmlURL, true);

  //       xmlRequest.responseType = "document";
  //       xmlRequest.send();
  //     }
  //   } catch (e) {
  //     console.log("Error at Version Update >>> ", e);
  //   }
  // }

  checkVersion = () => {
    let clientVersion = process.env.REACT_APP_CLIENT_VERSION;

    try {
      if (window.XMLHttpRequest) {
        let locationURL = new URL(window.location.href);
        console.log("Location URL: ", locationURL);

        let xmlRequest = new XMLHttpRequest();
        xmlRequest.onreadystatechange = (Event) => {
          if (Event.target.readyState === 4) {
            let xmlDocument = xmlRequest.responseXML;
            console.log("XML_DOCUMENT_RESPONSE", xmlDocument);
            if (xmlDocument) {
              let versionElement = xmlDocument.getElementsByTagName("version");
              let version = versionElement[0].textContent;
              console.log(
                "CLIENT_VERSION_NUMBER --> ",
                version,
                "CLIENT_VERSION --> ",
                clientVersion
              );
              if (version !== clientVersion) {
                let redirectionURL = new URL(
                  process.env.REACT_APP_CLIENT_ORIGIN +
                  process.env.REACT_APP_CLIENT_URL_PATH_NAME +
                  "index.html"
                );

                let locationURLSearchParams = new URLSearchParams(
                  locationURL.search
                );
                locationURLSearchParams.set("t", Math.random()); //replaces the existing timestamp (if any)

                redirectionURL.search = locationURLSearchParams.toString(); //updates with the remaining (if any) search params
                redirectionURL.hash = locationURL.hash; //hash (if already exists) in URL to be added

                console.log("redirectionURL:", redirectionURL);

                window.location.href = redirectionURL.href;
              }
            }
          }
        };

        xmlRequest.open(
          "GET",
          process.env.REACT_APP_CLIENT_ORIGIN +
          process.env.REACT_APP_CLIENT_URL_PATH_NAME +
          "version.xml?t=" +
          Math.random(),
          true
        );

        xmlRequest.responseType = "document";
        xmlRequest.send();
      }
    } catch (error) {
      console.log("Error at check version:", error);
    }
  };

  async componentDidMount() {
    window.document.addEventListener("visibilitychange", this.onDocumentVisibilityChange);

    window.addEventListener('tokenRefreshLoad', (e) => {
      console.log("tokenRefreshLoad event received with data: ", e.detail);
      if (e.detail.showLoader) {
        this.setState({ isLoading: true });
      } else {
        this.setState({ isLoading: true });
      }
    })

    window.dataToClient = async (message) => {
      console.log("The App.js message is CDM: ", JSON.parse(message))
      let refinedData = JSON.parse(message)
      if (refinedData.type && refinedData.type.toLowerCase() === "updatedtoken") {
        console.log("Updated Token received from Native: ", refinedData.token);
        let clientData = JSON.parse(window.sessionStorage.getItem("clientData"));
        console.log("clientData before setting token: ", clientData);
        if (clientData) {
          clientData.token = refinedData.token;
          clientData.a23Token = refinedData.a23Token;
          console.log("setting clientData in sessionStorage: ", clientData);
          window.sessionStorage.setItem("clientData", JSON.stringify(clientData))
        }
        window.sessionStorage.setItem("token", refinedData.token);
        window.sessionStorage.setItem("a23token", refinedData.a23Token);
        notifyTokenReceived(refinedData.token);
        return;
      }
      console.log(`window.sessionStorage["screenName"] >>> `, window.sessionStorage["screenName"])
      if (window.sessionStorage["screenName"] === undefined ||
        window.sessionStorage["aceLevel"] === undefined ||
        window.sessionStorage["totalBalance"] === undefined
        || window.sessionStorage["subscriptionType"] === "undefined") {
        console.log(`Before Calling token is `, refinedData.token);
        console.log("Debug log Invoking get profile data");
        const userProfile = await getProfileData(refinedData.token)
        console.log(`getProfileData >>> `, userProfile)
        window.sessionStorage.setItem("screenName", userProfile.data.screenName)
        window.sessionStorage.setItem("aceLevel", userProfile.data.currentAceLevelName)
        window.sessionStorage.setItem("totalBalance", userProfile.data.total)
        window.sessionStorage.setItem('subscriptionType', userProfile.data.subscriptionType)
        console.log('User Profile: ', userProfile)
      }
      window.sessionStorage.setItem("clientData", message)
      window.sessionStorage.setItem("a23token", refinedData.a23Token);
      window.sessionStorage.setItem("token", refinedData.token);
      window.sessionStorage.setItem("pushNotificationEnable", refinedData.pushNotificationEnable);
      if (refinedData.activeOffersCTData) {
        window.sessionStorage.setItem("CTBannerData", JSON.stringify(refinedData.activeOffersCTData))
      }
      if (refinedData.type) {
        window.sessionStorage.setItem("type", refinedData.type)
      }
      window.sessionStorage.setItem("userid", refinedData._id);
      window.sessionStorage.setItem("channel", refinedData.channel);
      window.sessionStorage.setItem("appVersion", refinedData.appVersion);
      // window.sessionStorage.setItem("channel", refinedData.channel);
      window.sessionStorage.setItem("channelCheckForRedeem", refinedData.channelCheckForRedeem);
      window.sessionStorage.setItem("kycStatus", refinedData.kycStatus);
      window.sessionStorage.setItem("clickLocation", refinedData?.clickLocation);
      window.sessionStorage.setItem("panStatus", refinedData.panStatus);
      window.sessionStorage.setItem("referClickLocation", refinedData.referClickLocation)
      console.log("reactLocation>>>>>>", refinedData.reactLocation);
      window.sessionStorage.setItem("tdsHistoryPageAvailable", refinedData.tdsHistoryPageAvailable);
      console.log("componentDidMount called in App.js", refinedData.showWatchAds)
      window.sessionStorage.setItem("showWatchAds", refinedData.showWatchAds);
      console.log("selectedLanguage>>>>>>", refinedData.selectedLanguage);
      window.sessionStorage.setItem("selectedLanguage", refinedData.selectedLanguage ? refinedData.selectedLanguage : "en");
      console.log("selected lang >>>>>>", window.sessionStorage.getItem("selectedLanguage"));
      window.sessionStorage.setItem("pokerPlayBalance", refinedData.pokerPlayBalance);
      if (refinedData.reactLocation) {
        window.sessionStorage.setItem("reactLocation", refinedData.reactLocation);
      }
      if (refinedData.withDrawClickAdFlowEnabled) {
        window.sessionStorage.setItem("withDrawClickAdFlowEnabled", refinedData.withDrawClickAdFlowEnabled);
      }

      this.setState({
        initialStorage: true
      })
    }

    setStaticDataToSessionStorage();

    // window.sessionStorage.setItem("showWatchAds", false);

    // AdSense: Native-to-Web ad push bridge
    const adQueue = [];

     // setTimeout(() => {
    //   console.log("Timeout executing ad one");
    //   adQueue.push({
    //     divId: "top-video-ad",
    //     display: "inline-block",
    //     size: [320, 250],
    //     adClient: "ca-pub-5744175347136273",
    //     adSlot: "8473817854"
    //   })
    //   displayNextAd();
    // }, 4000);

    setTimeout(() => {
      console.log("Timeout executing ad");
      adQueue.push({
        divId: "wallet-video-ad",
        display: "inline-block",
        size: [320, 250],
        adClient: "ca-pub-5744175347136273",
        adSlot: "5513738325",
      })
      displayNextAd();
    }, 2000);

    function displayNextAd() {
      if (adQueue.length === 0) return;

      const adConfig = adQueue.shift();
      console.log("Displaying AdSense ad:", adConfig);

      const container = document.getElementById(adConfig.divId);
      if (!container) {
        console.warn("Ad container not found:", adConfig.divId);
        return;
      }

      container.innerHTML = '';

      const adIns = document.createElement('ins');
      adIns.className = 'adsbygoogle';
      adIns.style.display = adConfig.display || 'block';
      adIns.setAttribute('data-ad-client', adConfig.adClient);
      adIns.setAttribute('data-ad-slot', adConfig.adSlot);
      adIns.setAttribute('data-adtest', 'on');

      if (adConfig.size) {
        // Fixed size mode: native specifies exact dimensions
        adIns.style.width = adConfig.size[0] + 'px';
        adIns.style.height = adConfig.size[1] + 'px';
      } else {
        // Responsive mode: Google picks the best ad size
        adIns.style.width = '100%';
        adIns.style.height = 'auto';
        adIns.setAttribute('data-ad-format', adConfig.format || 'auto');
        adIns.setAttribute('data-full-width-responsive', 'true');
      }

      container.appendChild(adIns);

      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    window.pushAdFromNative = function (adConfig) {
      console.log("Ad pushed from native:", adConfig);
      adQueue.push(adConfig);
      displayNextAd();
    };

    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search)
    if (!window.sessionStorage["token"]) {
      console.log("TOKEN NOT SET IN ND")
      if (params.get("channel") === 'ND' || params.get("channel") === 'MHTML') {
        window.sessionStorage.setItem("token", params.get("token"));
        console.log("TOKEN SHOULD SET IN ND")
        window.sessionStorage.setItem("a23token", params.get("a23Token"));
        window.sessionStorage.setItem("channel", params.get("channel"));
        // window.sessionStorage.setItem("appVersion", params.get("appVersion"));
        // window.sessionStorage.setItem("channelCheckForRedeem", params.get("channelRedeem"));
        try {
          console.log(`Before Calling token is `, params.get("token"));
          console.log("Debug log Invoking 22222 get profile data");
          const userProfile = await getProfileData(params.get("token"))
          window.sessionStorage.setItem("screenName", userProfile.data.screenName)
          window.sessionStorage.setItem("aceLevel", userProfile.data.currentAceLevelName)
          window.sessionStorage.setItem("kycStatus", userProfile.data.kycStatus);
          window.sessionStorage.setItem("panStatus", userProfile.data.panStatus);
          window.sessionStorage.setItem("userid", userProfile.data._id);
        } catch {
          console.log("GETPROFILEV2 API ERROR")
        }
        this.setState({
          initialStorage: true
        })
      }
    } else {
      this.setState({
        initialStorage: true
      })
    }


    // only for testing purpose @yashwanth
    function setStaticDataToSessionStorage() {
      console.log("A23 Token:", typeof window.sessionStorage.getItem("a23token"));
      console.log("Acelevel:", typeof window.sessionStorage.getItem("aceLevel"));
      console.log("App Version:", typeof window.sessionStorage.getItem("appVersion"));
      console.log("Channel:", typeof window.sessionStorage.getItem("channel"));
      console.log("channelCheckForRedeem:", typeof window.sessionStorage.getItem("channelCheckForRedeem"));
      console.log("clickLocation:", typeof window.sessionStorage.getItem("clickLocation"));
      console.log("clientData:", typeof window.sessionStorage.getItem("clientData"));
      console.log("isfrom:", typeof window.sessionStorage.getItem("isfrom"));
      console.log("kycStatus:", typeof window.sessionStorage.getItem("kycStatus"));
      console.log("mobile:", typeof window.sessionStorage.getItem("mobile"));
      console.log("panStatus:", typeof window.sessionStorage.getItem("panStatus"));
      console.log("pokerPlayBalance:", typeof window.sessionStorage.getItem("pokerPlayBalance"));
      console.log("pushNotificationEnable:", typeof window.sessionStorage.getItem("pushNotificationEnable"));
      console.log("referClickLocation:", typeof window.sessionStorage.getItem("referClickLocation"));
      console.log("screenName:", typeof window.sessionStorage.getItem("screenName"));
      console.log("selectedLanguage:", typeof window.sessionStorage.getItem("selectedLanguage"));
      console.log("showWatchAds:", typeof window.sessionStorage.getItem("showWatchAds"));
      console.log("subscriptionType:", typeof window.sessionStorage.getItem("subscriptionType"));
      console.log("tdsHistoryPageAvailableL:", typeof window.sessionStorage.getItem("tdsHistoryPageAvailable"));
      console.log("token:", typeof window.sessionStorage.getItem("token"));
      console.log("totalBalance:", typeof window.sessionStorage.getItem("totalBalance"));
      console.log("userid:", typeof window.sessionStorage.getItem("userid"));
      console.log("withDrawClickAdFlowEnabled:", typeof window.sessionStorage.getItem("withDrawClickAdFlowEnabled"));

      window.sessionStorage.setItem("a23token", "jnwNsLduDmrJuz7E9EaWYPxbAYs3rJoktrDcXlJNUaplmfG41flmpos+tHV+TN67iCvSrJoFrfgQV6MSkfqlFFJdsoAzwSB9WYpZs9jz5vftL/B/eEmlJhJMpwwvWCTSrLxllPNi4syDYJfw+1LP7kJBIqaJiFSWJXc9iU80XUQLbaSIhablVoSQFawm5+WsrYLTrZHSOHcV4RCNFmEzvi29on77CGu5fcPebeBwD5gwJP7h+P7MnOqs0OfPDt9wa2iDhByEbNs1QsPaeSUeKQx+XH7KGa8aMdN3wmNAQo3S4TCVAqbp/29rFUJlhUknr6v96AksegkuQASpHAfVc+aiZvoExfzeeWQFqNZKYp4=");
      window.sessionStorage.setItem("aceLevel", "bronze");
      window.sessionStorage.setItem("appVersion", "8.0.0");
      window.sessionStorage.setItem("channel", "GAPS");
      window.sessionStorage.setItem("channelCheckForRedeem", "true");
      window.sessionStorage.setItem("clickLocation", "rummyHeader");
      window.sessionStorage.setItem("clientData", JSON.stringify({"GoldVideoSeen":false,"_id":"y43h460g26a185j","a23Token":"jnwNsLduDmrJuz7E9EaWYPxbAYs3rJoktrDcXlJNUaplmfG41flmpos+tHV+TN67iCvSrJoFrfgQV6MSkfqlFFJdsoAzwSB9WYpZs9jz5vftL/B/eEmlJhJMpwwvWCTSrLxllPNi4syDYJfw+1LP7kJBIqaJiFSWJXc9iU80XUQLbaSIhablVoSQFawm5+WsrYLTrZHSOHcV4RCNFmEzvi29on77CGu5fcPebeBwD5gwJP7h+P7MnOqs0OfPDt9wa2iDhByEbNs1QsPaeSUeKQx+XH7KGa8aMdN3wmNAQo3S4TCVAqbp/29rFUJlhUknr6v96AksegkuQASpHAfVc+aiZvoExfzeeWQFqNZKYp4=","aceLevel":"bronze","appVersion":"8.0.0","channel":"GAPS","channelCheckForRedeem":true,"clickLocation":"rummyHeader","augmontConsent":false,"emailVerified":false,"isNewVersion":true,"kycDocNumber":"","kycStatus":"","panStatus":"","pushNotificationEnable":"true","showWatchAds":true,"subscriptionType":"premium","tdsHistoryPageAvailable":true,"token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJ5NDNoNDYwZzI2YTE4NWoiLCJzY3JlZW5OYW1lIjoiZ2hvc3RyaWRlcjExIiwibW9iaWxlIjoiKzkxODIzNDI1MjM0MiIsInN0YXR1cyI6dHJ1ZSwiZGV2aWNlX2lkIjoiODhiZTI0ZGFkNDAyZDEyNSIsImNoYW5uZWwiOiJHQVBTIiwicGxheWVyU3RhdHVzIjoibnVsbCIsIm5ldHdvcmtPcCI6InJ1bW15IiwiaWF0IjoxNzcxODM1MDk2LCJleHAiOjE3NzE5MjE0OTZ9.jDNDTd1p-kE0kVly9KMHuHmyIpX6AU_IydGgQ3aU_m8","unlistedLandingPageSeen":false,"userName":"ghostrider11","withDrawClickAdFlowEnabled":true}));
      window.sessionStorage.setItem("isfrom", "wallet");
      window.sessionStorage.setItem("kycStatus", "");
      window.sessionStorage.setItem("mobile", +918234252342);
      window.sessionStorage.setItem("panStatus", "");
      // window.sessionStorage.setItem("pokerPlayBalance", undefined);
      window.sessionStorage.setItem("pushNotificationEnable", true);
      // window.sessionStorage.setItem("referClickLocation", undefined);
      window.sessionStorage.setItem("screenName", "ghostrider11");
      window.sessionStorage.setItem("selectedLanguage", "en");
      window.sessionStorage.setItem("showWatchAds", "true");
      window.sessionStorage.setItem("subscriptionType", "premium");
      window.sessionStorage.setItem("tdsHistoryPageAvailable", "true");
      window.sessionStorage.setItem("token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJ5NDNoNDYwZzI2YTE4NWoiLCJzY3JlZW5OYW1lIjoiZ2hvc3RyaWRlcjExIiwibW9iaWxlIjoiKzkxODIzNDI1MjM0MiIsInN0YXR1cyI6dHJ1ZSwiZGV2aWNlX2lkIjoiODhiZTI0ZGFkNDAyZDEyNSIsImNoYW5uZWwiOiJHQVBTIiwicGxheWVyU3RhdHVzIjoibnVsbCIsIm5ldHdvcmtPcCI6InJ1bW15IiwiaWF0IjoxNzcxODM1MDk2LCJleHAiOjE3NzE5MjE0OTZ9.jDNDTd1p-kE0kVly9KMHuHmyIpX6AU_IydGgQ3aU_m8");
      window.sessionStorage.setItem("totalBalance", "8811.42");
      window.sessionStorage.setItem("userid", "y43h460g26a185j");
      window.sessionStorage.setItem("withDrawClickAdFlowEnabled", "true");
    }


  }

  componentWillUnmount() {
    window.sessionStorage.removeItem("withDrawClickAdFlowEnabled");
  }

  render() {
    return (
      <UserProvider>
        <LanguageProvider>
          <div id="appDiv" style={{ position: "absolute", width: "100%", height: "100%", display: "" }}>
            {/* <AdBanner divId="top-video-ad" /> */}
            {/* <div id='wallet-video-ad' style={{
                width: "100%",
                height: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px auto",
                border: "1px dashed rgba(255, 255, 255, 0.4)",
                    borderRadius: "4px",
                    background: "linear-gradient(135deg, rgba(44,83,145,0.3), rgba(100,60,180,0.2))",
                    fontSize: "11px",
                    color: "rgba(255, 255, 255, 0.5)",
            }}></div> */}
            {this.state.initialStorage && !this.state.isLoading ?
              <Provider store={store}>
                {/* <HashRouter>  */}

                <Router>
                  <Suspense>
                    <Switch>
                      <Route exact path="/" component={WalletInfoRevamp} />
                      {/* <Route exact path="/cashback/" component={Cashback} /> */}
                      <Route path="/profile/" component={profile} />
                      <Route path="/responsiblegamingquestionnaire/" component={responsiblegamingquestionnaire} />
                      <Route path="/rummyrules/" component={rummyrules} />
                      <Route path="/aboutrummy/" component={aboutrummy} />
                      <Route path="/termsandconditions/" component={termsandconditions} />
                      <Route path="/myaccount/" component={myaccount} />
                      <Route path="/bonussummary/" component={bonussummary} />
                      <Route path="/rummyvariants/" component={rummyvariants} />
                      <Route path="/requestredeem/" component={requestredeem} />
                      <Route path="/changepassword/" component={changepassword} />
                      <Route path="/addupi/" component={addupi} />
                      <Route path="/redeem/" component={redeem} />
                      <Route path="/redeemStatus/" component={redeemRequestStatus} />
                      <Route path="/redeemhistory/" component={redeemhistorytwo} />
                      <Route path="/addbankaccount/" component={addbankaccount} />
                      <Route path="/bankverificationalert/" component={bankverificationalert} />
                      <Route path="/sampleaddcash/" component={sampleaddcash} />
                      <Route path="/apppreferences/" component={apppreferences} />
                      <Route path="/walletinfo/" component={WalletInfoRevamp} />
                      {/* <Route path="/walletinfo/" component={walletinfo} /> */}
                      <Route path="/ifscpage/" component={ifscpage} />
                      <Route path="/redeemacepoints/" component={redeemacepoints} />
                      <Route path="/acepoints_termsandconditons/" component={acepoints_termsandconditons} />
                      <Route path="/redeeminfo/" component={redeeminfo} />
                      <Route path="/transactionsummary/" component={TransactionSummary} />
                      {/* <Route path="/transactionsummary/" component={BS2} /> */}
                      <Route path="/failedtranscations/" component={failedtranscations} />
                      {/* <Route path="/failedtranscations/" component={ft2} /> */}
                      <Route path="/summerybonus/" component={summarybonus} />
                      {/* <Route path="/activeoffers/" component={SB2}></Route> */}
                      {/* <Route path="/summerybonus/" component={SB2} /> */}
                      <Route path="/activeoffers/" component={ActiveOffers}></Route>
                      <Route path="/bonusoffers/" component={bonusoffers} />
                      <Route path="/loyalty/" component={loyalty} />
                      <Route path="/promotions/" component={Promotions} />
                    </Switch>
                  </Suspense>
                  <Alert />
                  <ModelContainer />
                </Router>
                {/* </HashRouter>  */}
              </Provider>
              :
              sessionStorage.getItem("channel") !== null ?
                <div className='loader' style={{ position: "absolute", width: "100%", height: "100%", top: "0px", left: "0px", display: "flex", justifyContent: "center" }}>
                  {this.state.enableHeader !== 'N' ?
                    <nav className='navbar'>
                      <div className="nav-container" >
                        <img
                          alt="back btn"
                          className='backBtn'
                          src={navarrow}
                          style={{ width: "40px" }}
                          onClick={() => WebToNativeMessage('closeClient')}
                        />
                      </div>
                    </nav>
                    :
                    null
                  }
                  <div id="nee yeb" style={{
                    width: "100%", height: "100%", position: 'absolute', display: "flex", justifyContent: "center", alignItems: "center"
                    //  transform: 'translate(-50%, -50%)',
                  }}>
                    <Loading />
                  </div>
                </div>
                : null
            }
          </div>
        </LanguageProvider>
      </UserProvider>
    );
  }


}

export default hot(module)(App);
